import axios from 'axios'

export async function getAddress(cep) {
    if (cep.length === 8) {
      const res = await axios(`https://cep.awesomeapi.com.br/json/${cep}`)
      const { data } = res
      return data
    }
}
